import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/index.css';

/*
  Removes the default 'Accept: application/json, text/plain, *'
  header to allow preloading of endpoints
 */
delete axios.defaults.headers.common.Accept;
// FIXME: change to better method to get the locale
axios.defaults.headers.common['Accept-Language'] = 'zh-hk';

const element = document.getElementById('root');
ReactDOM.render(<App />, element);
